import assetPath from '/app/xinglets/jobs/pages/search/src/assets/pride-brackground.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')